import { Injectable } from '@angular/core';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';

@Injectable({
    providedIn: 'root'
})

export class ApplicationVersionDataService
{
    constructor(private dataProvider: DataService) {
    }

    async getApplicationVersionList(applicationVersionListRequest: any): Promise<any> {
        return this.dataProvider.Post<any>(Urls.GetApplicationVersionList,applicationVersionListRequest).toPromise();
    }
    async getVersionNumberList(): Promise<any> {
        return this.dataProvider.Get<any>(Urls.GetVersionNumberList).toPromise();
    }
    async addApplicationVersion(viewModel:any):Promise<any> {
        return this.dataProvider.Post<any>(Urls.AddApplicationVersion,viewModel).toPromise();
    }
    async getApplicationVersionById(id:number):Promise<any> {
        return this.dataProvider.Get<any>(Urls.GetApplicationVersionById,id).toPromise();
    }
    async editApplicationVersion(viewModel:any):Promise<any> {
        return this.dataProvider.Put<any>(Urls.EditApplicationVersion,viewModel).toPromise();
    }
}
